export const extractUnit = (value: string | number | null, supportedUnits: string[]) => {
  if (typeof value !== 'string') return null;

  for (const unit of supportedUnits) {
    if (value.endsWith(unit)) {
      return unit;
    }
  }

  return null;
};
